import React, { createContext, useContext, useState } from 'react';

const RatingsContext = createContext();

export function RatingsProvider({ children }) {
  const [kpaRatings, setKpaRatings] = useState({ selfRatingData: null, lineManagerRatingData: null });
  const [standardsRatings, setStandardsRatings] = useState({ selfRatingData: null, lineManagerRatingData: null });

  return (
    <RatingsContext.Provider value={{ kpaRatings, setKpaRatings, standardsRatings, setStandardsRatings }}>
      {children}
    </RatingsContext.Provider>
  );
}

export function useRatings() {
  return useContext(RatingsContext);
}
